import { render } from "./CampagnesOverview.vue?vue&type=template&id=4752d893&scoped=true"
import script from "./CampagnesOverview.vue?vue&type=script&lang=js"
export * from "./CampagnesOverview.vue?vue&type=script&lang=js"

import "./CampagnesOverview.vue?vue&type=style&index=0&id=4752d893&scoped=true&lang=css"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4752d893"]])

export default __exports__